<div class="container mx-auto px-4 py-6">

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center py-20">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && fornecedor">
    <!-- Header / Breadcrumb -->
    <div class="mb-6 flex items-center gap-3">
      <button (click)="goBack()" class="text-gray-500 hover:text-gray-700 text-sm">← Fornecedores</button>
      <span class="text-gray-400">/</span>
      <h1 class="text-2xl font-bold text-gray-800">{{ fornecedor.nome }}</h1>
    </div>

    <!-- Info Header Card -->
    <div class="bg-white rounded-lg shadow p-6 mb-6">
      <div class="flex flex-col md:flex-row md:items-start justify-between gap-4">
        <!-- Main Info -->
        <div class="flex-1">
          <div class="flex flex-wrap items-center gap-2 mb-3">
            <span class="px-3 py-1 rounded-full text-sm font-semibold"
              [ngClass]="getStatusClass(fornecedor.status ?? 'Ativo')">
              {{ fornecedor.status ?? 'Ativo' }}
            </span>
            <span class="px-3 py-1 rounded-full text-sm font-semibold"
              [ngClass]="isVitrine(fornecedor) ? 'bg-amber-100 text-amber-800' : 'bg-gray-100 text-gray-700'">
              {{ getPlanLabel(fornecedor) }}
            </span>
            <span *ngIf="fornecedor.seloFornecedor"
              class="px-2 py-1 rounded text-xs font-medium bg-green-100 text-green-800">🏅 Selo Fornecedor</span>
            <span *ngIf="fornecedor.destaque"
              class="px-2 py-1 rounded text-xs font-medium bg-yellow-100 text-yellow-800">⭐ Destaque</span>
            <span *ngIf="fornecedor.isClaimed === true"
              class="px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-800">✓ Claimed</span>
            <span *ngIf="fornecedor.isClaimed === false"
              class="px-2 py-1 rounded text-xs font-medium bg-orange-100 text-orange-800">👻 Shadow Profile</span>
            <span *ngIf="fornecedor.publicado === true"
              class="px-2 py-1 rounded text-xs font-medium bg-teal-100 text-teal-800">📢 Publicado</span>
            <span *ngIf="fornecedor.publicado === false"
              class="px-2 py-1 rounded text-xs font-medium bg-gray-100 text-gray-600">📝 Não Publicado</span>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div *ngIf="fornecedor.email" class="flex items-center gap-2">
              <span class="text-gray-500">✉️</span>
              <a [href]="'mailto:' + fornecedor.email" class="text-blue-600 hover:underline">{{ fornecedor.email }}</a>
            </div>
            <div *ngIf="fornecedor.telefone" class="flex items-center gap-2">
              <span class="text-gray-500">☎️</span>
              <span>{{ fornecedor.telefone }}</span>
            </div>
            <div *ngIf="fornecedor.cidades && fornecedor.cidades.length > 0" class="flex items-start gap-2">
              <span class="text-gray-500">🌆</span>
              <div class="flex flex-wrap gap-1">
                <span *ngFor="let c of fornecedor.cidades" class="inline-block px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded border border-blue-200">
                  {{ c.nome || c }} <span class="text-blue-500 font-medium">({{ c.estado }})</span>
                </span>
              </div>
            </div>
            <div *ngIf="fornecedor.cidade && !(fornecedor.cidades && fornecedor.cidades.length > 0)" class="flex items-center gap-2">
              <span class="text-gray-500">📍</span>
              <span>{{ fornecedor.cidade }}{{ fornecedor.estado ? ' - ' + fornecedor.estado : '' }}</span>
            </div>
            <div *ngIf="fornecedor.website" class="flex items-center gap-2">
              <span class="text-gray-500">🌐</span>
              <a [href]="fornecedor.website" target="_blank" class="text-blue-600 hover:underline truncate max-w-[180px]">{{ fornecedor.website }}</a>
            </div>
            <div *ngIf="fornecedor.cnpj" class="flex items-center gap-2">
              <span class="text-gray-500">🏢</span>
              <span class="font-mono">{{ fornecedor.cnpj }}</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="text-gray-500">📅</span>
              <span class="text-gray-600">Desde {{ fornecedor.createdAt | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>

        <!-- Quick Actions -->
        <div class="flex flex-wrap gap-2">
          <button (click)="toggleAtivo()" [disabled]="saving"
            class="px-4 py-2 rounded-md text-sm font-medium transition disabled:opacity-60"
            [ngClass]="fornecedor.ativo ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' : 'bg-green-500 text-white hover:bg-green-600'">
            {{ fornecedor.ativo ? '⏸️ Desativar' : '▶️ Ativar' }}
          </button>
          <button (click)="togglePublicado()" [disabled]="saving"
            class="px-4 py-2 rounded-md text-sm font-medium transition disabled:opacity-60"
            [ngClass]="fornecedor.publicado ? 'bg-orange-100 text-orange-700 hover:bg-orange-200' : 'bg-teal-500 text-white hover:bg-teal-600'">
            {{ fornecedor.publicado ? '🔒 Despublicar' : '📢 Publicar' }}
          </button>
          <button *ngIf="!isVitrine(fornecedor)" (click)="openUpgradeModal()"
            class="px-4 py-2 bg-amber-500 text-white rounded-md hover:bg-amber-600 transition text-sm font-medium">
            ⬆️ Fazer Upgrade
          </button>
          <button *ngIf="isVitrine(fornecedor)" (click)="openDowngradeModal()"
            class="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition text-sm font-medium">
            ⬇️ Fazer Downgrade
          </button>
          <button (click)="resendWelcomeEmail()" [disabled]="resending"
            class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition text-sm font-medium disabled:opacity-60">
            {{ resending ? '📧 Enviando...' : '📧 Reenviar Email' }}
          </button>
          <button (click)="resetLeads()"
            class="px-4 py-2 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition text-sm font-medium">
            🔄 Resetar Leads
          </button>
          <a [routerLink]="['/admin/fornecedores', fornecedor.id, 'edit']"
            class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition text-sm font-medium">
            ✏️ Editar
          </a>
          <a [routerLink]="['/admin/fornecedores', fornecedor.id, 'preview']"
            class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition text-sm font-medium">
            👁️ Preview
          </a>
        </div>
      </div>
    </div>

    <!-- Stats + Subscription Row -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">

      <!-- Statistics Section -->
      <div class="bg-white rounded-lg shadow p-6">
        <h2 class="text-lg font-semibold text-gray-800 mb-4">📊 Estatísticas</h2>
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
          <div class="bg-blue-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-blue-800">{{ fornecedor.leadCount ?? fornecedor.leads ?? 0 }}</div>
            <div class="text-xs text-blue-600 mt-1">📞 Leads Totais</div>
          </div>
          <div class="bg-green-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-green-800">{{ fornecedor.stats?.acceptedLeads ?? 0 }}</div>
            <div class="text-xs text-green-600 mt-1">✅ Aceitos</div>
          </div>
          <div class="bg-red-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-red-800">{{ fornecedor.stats?.rejectedLeads ?? 0 }}</div>
            <div class="text-xs text-red-600 mt-1">❌ Rejeitados</div>
          </div>
          <div class="bg-purple-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-purple-800">{{ getAcceptanceRate(fornecedor) }}%</div>
            <div class="text-xs text-purple-600 mt-1">📊 Taxa Aceitação</div>
          </div>
          <div class="bg-orange-50 rounded-lg p-3 text-center">
            <div class="text-2xl font-bold text-orange-800">
              {{ fornecedor.stats?.avgResponseTime ? (fornecedor.stats.avgResponseTime + 'h') : '—' }}
            </div>
            <div class="text-xs text-orange-600 mt-1">⏱️ Tempo Médio</div>
          </div>
          <div class="bg-emerald-50 rounded-lg p-3 text-center">
            <div class="text-lg font-bold text-emerald-800">
              {{ fornecedor.stats?.totalRevenue ? ('R$ ' + (fornecedor.stats.totalRevenue | number:'1.0-0')) : '—' }}
            </div>
            <div class="text-xs text-emerald-600 mt-1">💰 Receita Total</div>
          </div>
        </div>
      </div>

      <!-- Subscription Section -->
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-800">💳 Informações de Assinatura</h2>
          <button (click)="openSubscriptionModal()"
            class="px-3 py-1.5 text-xs font-medium bg-indigo-600 text-white rounded hover:bg-indigo-700 transition">
            ✏️ Editar Assinatura
          </button>
        </div>
        <div class="space-y-3 text-sm">
          <div class="flex items-center justify-between py-2 border-b border-gray-100">
            <span class="text-gray-500">Status da Assinatura</span>
            <span class="font-medium px-2 py-0.5 rounded text-xs"
              [ngClass]="getPaymentStatusClass(fornecedor)">
              {{ getPaymentStatusLabel(fornecedor) }}
            </span>
          </div>
          <div class="flex items-center justify-between py-2 border-b border-gray-100">
            <span class="text-gray-500">📅 Data de Expiração</span>
            <span class="font-medium">
              {{ getSubscriptionExpiryDate(fornecedor) ? (getSubscriptionExpiryDate(fornecedor) | date:'dd/MM/yyyy') : '—' }}
            </span>
          </div>
          <div class="flex items-center justify-between py-2 border-b border-gray-100">
            <span class="text-gray-500">🔄 Renovação Automática</span>
            <span class="font-medium">{{ getAutoRenew(fornecedor) === true ? '✅ Sim' : getAutoRenew(fornecedor) === false ? '❌ Não' : '—' }}</span>
          </div>
          <div class="flex items-center justify-between py-2 border-b border-gray-100">
            <span class="text-gray-500">💳 Método de Pagamento</span>
            <span class="font-medium">
              {{ getPaymentMethodLabel(getPaymentMethod(fornecedor)) }}
            </span>
          </div>
          <div class="flex items-center justify-between py-2">
            <span class="text-gray-500">📅 Vitrine Desde</span>
            <span class="font-medium">
              {{ getVitrineSinceDate(fornecedor) ? (getVitrineSinceDate(fornecedor) | date:'dd/MM/yyyy') : '—' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Description -->
    <div *ngIf="fornecedor.descricao" class="bg-white rounded-lg shadow p-6 mb-6">
      <h2 class="text-lg font-semibold text-gray-800 mb-3">📝 Descrição</h2>
      <p class="text-sm text-gray-700 leading-relaxed whitespace-pre-line">{{ fornecedor.descricao }}</p>
    </div>

    <!-- Leads da Empresa -->
    <div class="bg-white rounded-lg shadow p-6 mb-6">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-lg font-semibold text-gray-800">📨 Leads Recebidos</h2>
        <span class="text-sm text-gray-500">Total: {{ leadsTotal }}</span>
      </div>

      <div *ngIf="leadsLoading" class="py-8 text-center">
        <app-spinner></app-spinner>
      </div>

      <div *ngIf="!leadsLoading">
        <div *ngIf="leads.length === 0" class="py-8 text-center text-gray-500">
          <div class="text-3xl mb-2">📭</div>
          <p class="text-sm">Nenhum lead encontrado</p>
        </div>

        <div *ngIf="leads.length > 0" class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200 text-sm">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Mensagem</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Data</th>
                <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Lido</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let l of leads" class="hover:bg-gray-50">
                <td class="px-4 py-3 font-medium text-gray-900">{{ l.nomeCliente || l.nome || l.clientName || '—' }}</td>
                <td class="px-4 py-3 text-gray-600">{{ l.emailCliente || l.email || '—' }}</td>
                <td class="px-4 py-3 text-gray-600 max-w-xs truncate" [title]="l.mensagem || l.message || ''">{{ l.mensagem || l.message || '—' }}</td>
                <td class="px-4 py-3 whitespace-nowrap text-gray-500">{{ l.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="px-4 py-3">
                  <span class="px-2 py-0.5 rounded-full text-xs font-medium"
                    [ngClass]="(l.isRead || l.lido) ? 'bg-gray-100 text-gray-600' : 'bg-blue-100 text-blue-800'">
                    {{ (l.isRead || l.lido) ? '✓ Lido' : '🔵 Novo' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Leads Pagination -->
          <div *ngIf="leadsTotal > leadsPageSize" class="mt-3 flex items-center justify-between text-sm text-gray-600">
            <span>Mostrando {{ (leadsPage - 1) * leadsPageSize + 1 }} a {{ leadsDisplayEnd() }} de {{ leadsTotal }}</span>
            <app-pagination [page]="leadsPage" [pageSize]="leadsPageSize" [total]="leadsTotal"
              (pageChange)="onLeadsPageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Transaction History -->
    <div *ngIf="fornecedor.recentTransactions?.length > 0" class="bg-white rounded-lg shadow p-6 mb-6">
      <h2 class="text-lg font-semibold text-gray-800 mb-4">💳 Histórico de Transações</h2>
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 text-sm">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Data</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Tipo</th>
              <th class="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">Valor</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Descrição</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let t of fornecedor.recentTransactions" class="hover:bg-gray-50">
              <td class="px-4 py-3 whitespace-nowrap">{{ t.date | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="px-4 py-3">
                <span class="text-sm">
                  {{ t.type === 'upgrade' ? '⬆️' : t.type === 'downgrade' ? '⬇️' : t.type === 'renewal' ? '🔄' : '↩️' }}
                  {{ t.type | titlecase }}
                </span>
              </td>
              <td class="px-4 py-3 text-right font-medium">R$ {{ t.amount | number:'1.2-2' }}</td>
              <td class="px-4 py-3 text-gray-600">{{ t.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Not found -->
  <div *ngIf="!loading && !fornecedor" class="text-center py-20 text-gray-500">
    <div class="text-5xl mb-4">🔍</div>
    <p class="text-lg font-medium">Fornecedor não encontrado</p>
    <button (click)="goBack()" class="mt-4 px-4 py-2 border rounded hover:bg-gray-50 text-sm">Voltar</button>
  </div>
</div>

<!-- ===== Upgrade Modal ===== -->
<div *ngIf="showUpgradeModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
    <div class="px-6 py-4 border-b flex items-center justify-between">
      <h2 class="text-xl font-semibold text-gray-800">⬆️ Fazer Upgrade para Vitrine</h2>
      <button (click)="closeUpgradeModal()" class="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
    </div>

    <form [formGroup]="upgradeForm" (ngSubmit)="submitUpgrade()" class="px-6 py-4 space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Motivo do Upgrade <span class="text-red-500">*</span></label>
        <select formControlName="reason"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="marketing">Campanha de Marketing</option>
          <option value="promotion">Promoção</option>
          <option value="complaint">Resolução de Reclamação</option>
          <option value="other">Outro</option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Desconto (%)</label>
        <input formControlName="discount" type="number" min="0" max="100"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
        <p class="text-xs text-gray-500 mt-1">Deixe 0 para sem desconto</p>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Data de Expiração <span class="text-red-500">*</span></label>
        <input formControlName="expiresAt" type="date"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
      </div>

      <div class="flex items-center gap-2">
        <input formControlName="notifySupplier" type="checkbox" id="notifyUpgrade" class="h-4 w-4 text-blue-600 rounded">
        <label for="notifyUpgrade" class="text-sm text-gray-700">Notificar fornecedor via email</label>
      </div>

      <!-- Preview -->
      <div class="bg-amber-50 border border-amber-200 rounded-md p-3 text-sm">
        <div class="flex justify-between">
          <span class="text-gray-600">Plano Atual:</span>
          <span class="font-medium">📦 Free</span>
        </div>
        <div class="flex justify-between mt-1">
          <span class="text-gray-600">Novo Plano:</span>
          <span class="font-medium text-amber-700">⭐ Vitrine</span>
        </div>
        <div *ngIf="upgradeForm.get('discount')?.value > 0" class="flex justify-between mt-1">
          <span class="text-gray-600">Desconto:</span>
          <span class="font-medium text-green-600">{{ upgradeForm.get('discount')?.value }}%</span>
        </div>
      </div>

      <div class="pt-2 flex justify-end gap-3 border-t">
        <button type="button" (click)="closeUpgradeModal()"
          class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 text-sm">Cancelar</button>
        <button type="submit" [disabled]="upgradeForm.invalid || upgrading"
          class="px-4 py-2 bg-amber-500 text-white rounded-md hover:bg-amber-600 text-sm disabled:opacity-60">
          {{ upgrading ? 'Processando...' : 'Confirmar Upgrade' }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- ===== Manual Subscription Edit Modal ===== -->
<div *ngIf="showSubscriptionModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-lg">
    <div class="px-6 py-4 border-b flex items-center justify-between">
      <h2 class="text-xl font-semibold text-gray-800">✏️ Editar Assinatura Manualmente</h2>
      <button (click)="closeSubscriptionModal()" class="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
    </div>

    <form [formGroup]="subscriptionForm" (ngSubmit)="submitSubscriptionEdit()" class="px-6 py-4 space-y-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Plano</label>
          <select formControlName="planLevel"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500">
            <option value="Free">📦 Free</option>
            <option value="Vitrine">⭐ Vitrine</option>
          </select>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Status de Pagamento</label>
          <select formControlName="paymentStatus"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500">
            <option value="active">✅ Ativa</option>
            <option value="pending">⏸️ Pendente</option>
            <option value="overdue">⏳ Em Atraso</option>
          </select>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Expiração da Assinatura</label>
          <input formControlName="expiresAt" type="date"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Vitrine Desde</label>
          <input formControlName="vitrineSinceDate" type="date"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Valor Mensal</label>
          <input formControlName="valorMensal" type="number" min="0" step="0.01"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="Ex.: 149.90">
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Motivo do ajuste</label>
        <textarea formControlName="reason" rows="2"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
          placeholder="Ex.: Ajuste solicitado pelo financeiro"></textarea>
      </div>

      <div class="pt-2 flex justify-end gap-3 border-t">
        <button type="button" (click)="closeSubscriptionModal()"
          class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 text-sm">Cancelar</button>
        <button type="submit" [disabled]="subscriptionForm.invalid || savingSubscription"
          class="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 text-sm disabled:opacity-60">
          {{ savingSubscription ? 'Salvando...' : 'Salvar Assinatura' }}
        </button>
      </div>
    </form>
  </div>
</div>

<!-- ===== Downgrade Modal ===== -->
<div *ngIf="showDowngradeModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-md">
    <div class="px-6 py-4 border-b flex items-center justify-between bg-red-50 rounded-t-lg">
      <h2 class="text-xl font-semibold text-red-800">⬇️ Fazer Downgrade para Free</h2>
      <button (click)="closeDowngradeModal()" class="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
    </div>

    <div class="px-6 py-4 bg-red-50 border-b border-red-200">
      <p class="font-medium text-red-800 mb-2">⚠️ Tem certeza que deseja fazer downgrade para Free?</p>
      <ul class="text-sm text-red-700 space-y-1 list-disc list-inside">
        <li>O fornecedor perderá os benefícios do plano Vitrine</li>
        <li>Leads disponíveis serão reduzidos a 5 por mês</li>
        <li>Uma notificação será enviada ao fornecedor</li>
      </ul>
    </div>

    <form [formGroup]="downgradeForm" (ngSubmit)="submitDowngrade()" class="px-6 py-4 space-y-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Motivo do Downgrade <span class="text-red-500">*</span></label>
        <textarea formControlName="reason" rows="4"
          placeholder="Explique o motivo do downgrade..."
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
          [ngClass]="{'border-red-500': downgradeForm.get('reason')?.invalid && downgradeForm.get('reason')?.touched}"></textarea>
        <p *ngIf="downgradeForm.get('reason')?.invalid && downgradeForm.get('reason')?.touched"
          class="text-xs text-red-500 mt-1">Motivo obrigatório (mínimo 10 caracteres)</p>
      </div>

      <div class="flex items-center gap-2">
        <input formControlName="notifySupplier" type="checkbox" id="notifyDowngrade" class="h-4 w-4 text-red-600 rounded">
        <label for="notifyDowngrade" class="text-sm text-gray-700">Notificar fornecedor via email</label>
      </div>

      <div class="pt-2 flex justify-end gap-3 border-t">
        <button type="button" (click)="closeDowngradeModal()"
          class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 text-sm">Cancelar</button>
        <button type="submit" [disabled]="downgradeForm.invalid || downgrading"
          class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 text-sm disabled:opacity-60">
          {{ downgrading ? 'Processando...' : '⚠️ Confirmar Downgrade' }}
        </button>
      </div>
    </form>
  </div>
</div>
